import { render, staticRenderFns } from "./CutWords.vue?vue&type=template&id=6b071e73&scoped=true"
import script from "./CutWords.vue?vue&type=script&lang=js"
export * from "./CutWords.vue?vue&type=script&lang=js"
import style0 from "./CutWords.vue?vue&type=style&index=0&id=6b071e73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b071e73",
  null
  
)

export default component.exports